import { cn } from '@/lib/utils'
import { FC, HTMLProps } from 'react'

interface TimerCircleProps extends HTMLProps<HTMLDivElement> {
	rounds: number
	currentRound: number
	currentPhaseDuration: number
	remainingTime: number
	phaseLabel: string
	radius: number
	strokeWidth: number
	isFinalCountdown?: boolean
}

const TRACK_PATH_LENGTH = 100

export const TimerCircle: FC<TimerCircleProps> = ({
	rounds,
	currentRound,
	currentPhaseDuration,
	remainingTime,
	phaseLabel,
	radius,
	strokeWidth,
	isFinalCountdown = false,
	className,
	...rest
}) => {
	const svgSize = radius * 2
	const svgCenter = svgSize / 2
	const normalizedRadius = radius - strokeWidth / 2
	const arcOffset = normalizedRadius * Math.SQRT1_2
	const horseshoePath = `M ${svgCenter - arcOffset} ${svgCenter + arcOffset}
		A ${normalizedRadius} ${normalizedRadius} 0 1 1 ${svgCenter + arcOffset} ${svgCenter + arcOffset}`
	const progress = currentPhaseDuration > 0 ? remainingTime / currentPhaseDuration : 0
	const clampedProgress = Math.max(0, Math.min(progress, 1))
	const progressLength = clampedProgress * TRACK_PATH_LENGTH

	return (
		<div {...rest} className={cn('relative', className)}>
			<svg height={svgSize} width={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
				<path
					d={horseshoePath}
					stroke='#DADADA'
					fill='transparent'
					strokeWidth={strokeWidth}
					strokeLinecap='round'
				/>
				<path
					d={horseshoePath}
					stroke='#CEE800'
					fill='transparent'
					strokeWidth={strokeWidth}
					strokeLinecap='round'
					pathLength={TRACK_PATH_LENGTH}
					strokeDasharray={TRACK_PATH_LENGTH}
					strokeDashoffset={TRACK_PATH_LENGTH - progressLength}
					style={{ transition: 'stroke-dashoffset 1s linear' }}
				/>
			</svg>

			<div className='absolute inset-0 flex flex-col items-center justify-center text-center'>
				<div className='text-[28px] font-medium text-[#1F1F1F]'>
					Раунд {currentRound}/{rounds}
				</div>
				<div
					className={cn(
						'mt-1 font-extrabold text-[70px] leading-none tabular-nums text-[#1F1F1F]',
						isFinalCountdown && 'animate-[pulse_0.45s_ease-in-out_infinite]'
					)}
					aria-live={isFinalCountdown ? 'assertive' : 'off'}>
					{String(Math.floor(remainingTime / 60)).padStart(2, '0')}:
					{String(remainingTime % 60).padStart(2, '0')}
				</div>
				<div className='mt-1 text-[28px] font-medium text-[#1F1F1F]'>{phaseLabel}</div>
			</div>
		</div>
	)
}
